import styled from "styled-components";

export const AboutStyles = styled.div`
  .container1{
    background-color: var(--primary-color);
    font-weight: bold;
    border-radius: 20px;
    padding: 2%;
    width: 87.5%;
    margin-left: 2.8%;
    
    /* justify-content: center;
    align-items: center; */

  }

`